document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    console.log('BOLD custom pricing script running...');
    const boldInterval = setInterval(() => {
      calculateBasePrice();
      calculateComparePrice();
    }, 500);
  });
});

function calculateBasePrice() {
  var basePrice = document.querySelector('.hidden_base_price').textContent;
  var optionsPrice;
  if (document.getElementsByName('properties[_boldVariantPrices]').length > 0) {
    optionsPrice = document.getElementsByName('properties[_boldVariantPrices]')[0].value.split(',');
  } else {
    optionsPrice = ['0'];
  }
  var finalPrice = 0;
  optionsPrice.forEach((price) => {
    finalPrice += parseInt(price);
  })
  finalPrice += parseInt(basePrice);
  var currency = document.querySelector('#hidden_currency').value;

  var finalPriceFormatted = (finalPrice / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
  var displayPrice = document.querySelectorAll('[data-m-price]');
  displayPrice.forEach((price) => {
    price.textContent = finalPriceFormatted;
  })
}

function calculateComparePrice() {
  var comparePrice = document.querySelector('.hidden_compare_price').textContent;
  var optionsPrice;
  if (document.getElementsByName('properties[_boldVariantPrices]').length > 0) {
    optionsPrice = document.getElementsByName('properties[_boldVariantPrices]')[0].value.split(',');
  } else {
    optionsPrice = ['0'];
  }
  var finalPrice = 0;
  optionsPrice.forEach((price) => {
    finalPrice += parseInt(price);
  })
  finalPrice += parseInt(comparePrice);
  var currency = document.querySelector('#hidden_currency').value;
  var finalPriceFormatted = (finalPrice / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
  var displayPrice = document.querySelectorAll('[data-compare-price]');
  displayPrice.forEach((price) => {
    price.textContent = finalPriceFormatted;
  })
}